/**
 * cd-pdp-cleanup.js
 *
 * Two PDP-only cleanup tasks that run once on DOMContentLoaded.
 *
 * 1. Preview-badge → reviews scroll
 *    The Judge.me preview badge above the product title is wrapped
 *    in `.cd-product-meta`. Click/Enter/Space scrolls to the cd-
 *    product-reviews section anchored at `#cd-pdp-reviews`. We
 *    don't wrap the badge in an <a> because that breaks Judge.me's
 *    own widget JS hydration.
 *
 * 2. Description "Sample Tutorial" line removal
 *    Some product descriptions contain a leftover "<Product Title>
 *    Sample Tutorial" line near the inline Vimeo iframe. The iframe
 *    itself is hidden via cd-pdp.css; this strips the orphaned text
 *    so it doesn't dangle. Conservative — only removes paragraphs
 *    short enough to plausibly be that label, never long-form text.
 *
 * Performance: runs once, walks ≤ ~30 paragraphs in `.product-
 * details`, micro-second-class string match. Imperceptible.
 */

(function () {
  function init() {
    // 1. Preview badge → scroll to reviews
    var badges = document.querySelectorAll('[data-cd-jump-to-reviews]');
    var target = document.getElementById('cd-pdp-reviews');
    if (badges.length && target) {
      var jump = function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var heading = target.querySelector('.cd-product-reviews__heading');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      };
      for (var i = 0; i < badges.length; i++) {
        var badge = badges[i];
        badge.addEventListener('click', jump);
        badge.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') jump(ev);
        });
      }
    }

    // 2. Strip "Sample Tutorial" / "Sample Video Tutorial" lines
    var details = document.querySelector('.product-details');
    if (details) {
      var nodes = details.querySelectorAll('p, h2, h3, h4, h5, h6');
      var pattern = /\bsample(?:\s+video)?\s+tutorial\b/i;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        var text = (n.textContent || '').trim();
        // Safety: only remove short paragraphs (<= 80 chars). Long
        // descriptive paragraphs that mention "sample tutorial" in
        // passing stay put.
        if (text.length > 0 && text.length <= 80 && pattern.test(text)) {
          n.remove();
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
